import ConfigurationContext from "@contexts/Configuration.context";
import { useConfiguration } from "@hooks/index";

const ConfigurationProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const env = useConfiguration();

  if (env === null) {
    return null;
  }
  
  return (
    <ConfigurationContext.Provider value={env}>
      {children}
    </ConfigurationContext.Provider>
  );
};

export default ConfigurationProvider;
